<div class="dashboard--module-header">
    <h2 class="subheading-sm">Friendly disconnect settings <button class="info-btn focus-element" (click)="onClickInfo()"><span class="focus--content" tabindex="-1"><span>i</span></span></button><span class="subheading--status" *ngIf="showProgress" [ngClass]="{'text-color__warning': (progress == 'In Progress'), 'text-color__success': (progress == 'Completed'), 'text-color__error': (progress == 'Error')}">{{progress}}</span></h2>
    <div class="btn-group">
        <ng-container *ngIf="!isEditing">
            <button class="focus-element" (click)="onEditClick()"><span class="focus--content" tabindex="-1" title="Edit friendly disconnect settings"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
            <button class="focus-element" *ngIf="progress != 'In Progress'" (click)="pollFriendlyInteraction()"><span class="focus--content" tabindex="-1" title="Request current friendly disconnect settings"><svg class="m-ic" [ngClass]="{'spin' : isProcessing}"><use xlink:href="#ic-refresh" href="#ic-refresh"></use></svg></span></button>
        </ng-container>
        <ng-container *ngIf="isEditing">
            <button class="focus-element" (click)="onEditClick(true)"><span class="focus--content" tabindex="-1" title="Update friendly disconnect settings with inputted values"><svg class="m-ic"><use xlink:href="#ic-save" href="#ic-save"></use></svg></span></button>
            <button class="focus-element" (click)="onEditClick()"><span class="focus--content" tabindex="-1" title="Cancel editing"><svg class="m-ic m-ic--sm"><use xlink:href="#ic-close" href="#ic-close"></use></svg></span></button>
        </ng-container>
    </div>
</div>
<div class="module--main">
    <ng-container *ngIf="!isEditing; else editDisconnect">
        <div class="row" *ngIf="friendlyDisconnectInteraction">
            <div class="col-md-9 col-sm-8 col-xs-12">
                <table class="flex-grid--item std-table stacked-sm">
                    <thead>
                    <th>Day</th>
                    <th>Disconnect?</th>
                    <th>From</th>
                    <th>To</th>
                    </thead>
                    <tbody>
                        <tr><td data-label="Day">Saturday</td><td data-label="Disconnect?">{{friendlyDisconnectInteraction.saturdayDisconnect ? 'Yes' : 'No'}}</td><td data-label="From">{{friendlyDisconnectInteraction.saturdayStartTime}}</td><td data-label="To">{{friendlyDisconnectInteraction.saturdayEndTime}}</td></tr>
                        <tr><td data-label="Day">Sunday</td><td data-label="Disconnect?">{{friendlyDisconnectInteraction.sundayDisconnect ? 'Yes' : 'No'}}</td><td data-label="From">{{friendlyDisconnectInteraction.sundayStartTime}}</td><td data-label="To">{{friendlyDisconnectInteraction.sundayEndTime}}</td></tr>
                        <tr><td data-label="Day">Weekday</td><td data-label="Disconnect?">{{friendlyDisconnectInteraction.weekdayDisconnect ? 'Yes' : 'No'}}</td><td data-label="From">{{friendlyDisconnectInteraction.weekdayStartTime}}</td><td data-label="To">{{friendlyDisconnectInteraction.weekdayEndTime}}</td></tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
                <form action="" class="flex-grid--item  std-form">
                    <div class="form-group">
                        <label class="text-left" style="font-weight: 700;padding: 0.25rem; font-size:0.9rem">Special days</label>
                        <ul class="checklist">
                            <li class="checklist--item" *ngFor="let specialDay of friendlyDisconnectInteraction.specialDays"><input type="checkbox" id="client4" disabled><label for="client4">{{specialDay | date:'dd/MM/yyyy'}} <svg class="ic-check"><use xlink:href="#ic-check" href="#ic-check"></use></svg></label></li>
                        </ul>
                    </div>
                </form>
            </div>
        </div>
        <div class="block-num text-center" *ngIf="!friendlyDisconnectInteraction">
            <span>No information on friendly disconnection settings</span>
        </div>
    </ng-container>
    <ng-template #editDisconnect>
        <div class="row">
            <div class="col-md-9 col-sm-8 col-xs-12">
                <form [formGroup]="form">
                    <table class="flex-grid--item std-table std-table__bare std-table__text-large stacked-sm">
                        <thead>
                        <th>Day</th>
                        <th>Disconnect?</th>
                        <th>From</th>
                        <th>To</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Day">Saturday</td>
                                <td data-label="Disconnect?">
                                    <div class="form-group">
                                        <div class="input-inline">
                                            <div class="checkbox"><input type="checkbox" id="saturdayDisconnect" [formControl]="form.controls.saturdayDisconnect"><label for="saturdayDisconnect"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>Yes</label></div>
                                        </div>
                                    </div>
                                </td>
                                <td data-label="From">
                                    <div class="form-group form-group__xsmall" *ngIf="form.value.saturdayDisconnect">
                                        <label class="sr-only">From</label>
                                        <time-picker [control]="form.controls.saturdayStartTime"></time-picker>
                                    </div>
                                </td>
                                <td data-label="To">
                                    <div class="form-group form-group__xsmall" *ngIf="form.value.saturdayDisconnect">
                                        <label class="sr-only">To</label>
                                        <time-picker [control]="form.controls.saturdayEndTime"></time-picker>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td data-label="Day">Sunday</td>
                                <td data-label="Disconnect?">
                                    <div class="form-group">
                                        <div class="input-inline">
                                            <div class="checkbox"> <input type="checkbox" id="sundayDisconnect" [formControl]="form.controls.sundayDisconnect"><label for="sundayDisconnect"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>Yes</label></div>
                                        </div>
                                    </div>
                                </td>
                                <td data-label="From">
                                    <div class="form-group form-group__xsmall" *ngIf="form.value.sundayDisconnect">
                                        <label class="sr-only">From</label>
                                        <time-picker [control]="form.controls.sundayStartTime"></time-picker>
                                    </div>
                                </td>
                                <td data-label="To">
                                    <div class="form-group form-group__xsmall" *ngIf="form.value.sundayDisconnect">
                                        <label class="sr-only">To</label>
                                        <time-picker [control]="form.controls.sundayEndTime"></time-picker>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td data-label="Day">Weekday</td>
                                <td data-label="Disconnect?">
                                    <div class="form-group">
                                        <div class="input-inline">
                                            <div class="checkbox"> <input type="checkbox" id="weekdayDisconnect" [formControl]="form.controls.weekdayDisconnect"><label for="weekdayDisconnect"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>Yes</label></div>
                                        </div>
                                    </div>
                                </td>
                                <td data-label="From">
                                    <div class="form-group form-group__xsmall" *ngIf="form.value.weekdayDisconnect">
                                        <label class="sr-only">From</label>
                                        <time-picker [control]="form.controls.weekdayStartTime"></time-picker>
                                    </div>
                                </td>
                                <td data-label="To">
                                    <div class="form-group form-group__xsmall" *ngIf="form.value.weekdayDisconnect">
                                        <label class="sr-only">To</label>
                                        <time-picker [control]="form.controls.weekdayEndTime"></time-picker>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
                <div class="flex-grid--item  std-form">
                    <form [formGroup]="form" (submit)="onAddSpecialDateClick()">
                        <div class="form-group">
                            <label for="special-days" class="text-left" style="font-weight: 700; padding: 0.25rem;">Special days</label>
                            <div class="input-addon input-addon__std right">
                                <input type="text" id="special-days" class="input-addon__std--input" placeholder="dd/mm/yyyy" [textMask]="{mask: dateMask, pipe: dateAutoCorrectPipe, guide: false}" [formControl]="form.controls.specialDay">
                                <button class="input-addon__std--btn-overlay focus-element"><span class="focus--content" tabindex="-1"><svg class="input-addon__std--btn-overlay__ic"><use xlink:href="#ic-add" href="#ic-add"></use></svg></span></button>
                            </div>
                            <ul class="checklist">
                                <li class="checklist--item" *ngFor="let item of form.value.specialDays; let i = index">
                                    <input type="checkbox" id="date-{{i}}" [checked]="item.selected" (click)="onSpecialDateClick(item)"><label for="date-{{i}}">{{item.date | date:'dd/MM/yyyy'}} <svg class="ic-check"><use xlink:href="#ic-check" href="#ic-check"></use></svg></label>
                                </li>
                            </ul>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>
</div>
